/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { Program } from '@wit/vtv-x-foundation-lib';
import translate from 'services/i18n/translate';
import useAssetTitle from '../../../hooks/useAssetTitle';

interface Props {
  nextPrograms: Program[];
}

export default function LiveEventDetails({ nextPrograms }: Props): JSX.Element {
  const thirdFutureProgram = nextPrograms[2];
  const nextTitle = useAssetTitle(nextPrograms[0], false);
  const thenTitle = useAssetTitle(nextPrograms[1], false);
  const thirdTitle = useAssetTitle(thirdFutureProgram, false);

  return (
    <>
      <h6 id="ProgrammeInfoDetails_nextTitle">{translate['watchtv.next']}</h6>
      <span id="ProgrammeInfoDetails_next">{nextTitle}</span>

      <h6 id="ProgrammeInfoDetails_thenTitle">{translate['watchtv.then']}</h6>
      <span id="ProgrammeInfoDetails_then">{thenTitle}</span>

      {thirdFutureProgram && thirdFutureProgram.startTime && thirdFutureProgram.endTime ? (
        <>
          <h6 id="ProgrammeInfoDetails_thirdTitle">{`${thirdFutureProgram.startTime} - ${thirdFutureProgram.endTime}`}</h6>
          <span id="ProgrammeInfoDetails_third">{thirdTitle}</span>
        </>
      ) : null}
    </>
  );
}
